module.exports = __webpack_public_path__ + "assets/img/trait3.c5174d66.png";